
define('text!modules/targeting/contextual/templates/grid_footer.html',[],function () { return '<div class="w-foot-c">\n    <div class="stack browse-path" data-bind="browse_path">{{{browse_path}}}\n        <span class="strong">{{{browse_path_end}}}&nbsp;</span>\n    </div>\n</div>';});

